import { useState } from "react";
import { inviteErrorText } from "../lib/inviteErrors.js";
import styles from "../../../shared/components/shell.module.css";

export function InviteForm({
  pending,
  succeeded,
  errorCode,
  errorStatus,
  onInvite,
}: {
  pending: boolean;
  succeeded: boolean;
  errorCode: string | null;
  /** HTTP-Status, falls bekannt – steht im Rückfalltext. */
  errorStatus?: number | undefined;
  onInvite: (input: {
    email: string;
    name: string;
    role: "teacher" | "school_admin";
  }) => void;
}) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState<"teacher" | "school_admin">("teacher");

  return (
    // Die Marke der Führung liegt an der KARTE und nicht am Absendeknopf: der
    // ist leer noch abgeschaltet, und ein Ring um ein abgeschaltetes
    // Bedienelement zeigt auf eine Sackgasse. Hervorgehoben wird der Vorgang.
    <div className={`${styles.card} ${styles.spaced}`} data-tour="einladen">
      <h2 className={styles.title} style={{ fontSize: "1.15rem" }}>
        Lehrkraft hinzufügen
      </h2>

      {succeeded && (
        <div className={`${styles.notice} ${styles.noticeGood}`}>
          Einladung verschickt. Die Kollegin oder der Kollege erhält eine E-Mail mit einem
          Anmeldelink.
        </div>
      )}
      {errorCode && (
        <div className={`${styles.notice} ${styles.noticeError}`}>
          {inviteErrorText(errorCode, errorStatus)}
        </div>
      )}

      <form
        onSubmit={(event) => {
          event.preventDefault();
          onInvite({ email, name, role });
        }}
      >
        <div className={styles.spaced}>
          <label htmlFor="name">Name</label>
          <input
            id="name"
            className={styles.field}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Frau Berger"
            required
          />
        </div>
        <div className={styles.spaced}>
          <label htmlFor="invite-email">Dienstliche E-Mail-Adresse</label>
          <input
            id="invite-email"
            className={styles.field}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@schule.de"
            required
          />
        </div>
        <div className={styles.spaced}>
          <label htmlFor="role">Rolle</label>
          <select
            id="role"
            className={styles.field}
            value={role}
            onChange={(e) => setRole(e.target.value as "teacher" | "school_admin")}
          >
            <option value="teacher">Lehrkraft</option>
            <option value="school_admin">Schulleitung</option>
          </select>
        </div>
        <div className={`${styles.row} ${styles.spaced}`}>
          <button
            type="submit"
            className={styles.button}
            disabled={pending || email.trim() === "" || name.trim() === ""}
          >
            {pending ? "Wird eingeladen …" : "Einladung senden"}
          </button>
        </div>
      </form>
    </div>
  );
}
